import { useState } from "react";
import { Plus, Trash2 } from "lucide-react";
import { Txt, Num, Sel, Toggle, SectionHead, slug } from "./fields";

const UNITS = [["fixed", "Fixed"], ["sqft", "Per sq.ft"], ["unit", "Per room"]];

export default function AddonsAdmin({ rc, setRc }) {
  const [newLabel, setNewLabel] = useState("");
  const addons = rc.addons;
  const sorted = Object.entries(addons).sort((a, b) => (a[1].order || 0) - (b[1].order || 0));
  const set = (k, patch) => setRc({ ...rc, addons: { ...addons, [k]: { ...addons[k], ...patch } } });
  const add = () => {
    const k = slug(newLabel);
    if (!k || addons[k]) return;
    setRc({ ...rc, addons: { ...addons, [k]: { label: newLabel.trim(), description: "", price: 10000, unit: "fixed", order: sorted.length + 1, active: true } } });
    setNewLabel("");
  };
  const remove = (k) => { const a = { ...addons }; delete a[k]; setRc({ ...rc, addons: a }); };

  return (
    <div data-testid="admin-addons">
      <SectionHead title="Add-ons" sub="Optional extras clients can toggle on. Pricing basis: fixed, per sq.ft of the home, or per included room."
        action={<div className="flex gap-2"><Txt value={newLabel} onChange={setNewLabel} placeholder="New add-on name" className="w-56" testid="new-addon-input" />
          <button onClick={add} className="inline-flex items-center gap-1 rounded-full bg-brand-ink text-brand-cream text-sm px-4 py-2" data-testid="add-addon-btn"><Plus className="w-4 h-4" /> Add</button></div>} />
      <div className="rounded-2xl border border-brand-line bg-brand-cream overflow-hidden">
        <div className="grid grid-cols-12 gap-3 px-4 py-2 bg-brand-sand text-[10px] uppercase tracking-[0.15em] text-brand-muted-light">
          <span className="col-span-3">Add-on</span><span className="col-span-3">Description</span><span className="col-span-2">Price (₹)</span><span className="col-span-2">Basis</span><span className="col-span-1">Order</span><span className="col-span-1" />
        </div>
        {sorted.map(([k, a]) => (
          <div key={k} className={`grid grid-cols-12 gap-3 items-center px-4 py-3 border-t border-brand-line ${a.active ? "" : "opacity-60 bg-brand-sand"}`} data-testid={`addon-row-${k}`}>
            <div className="col-span-3"><Txt value={a.label} onChange={(v) => set(k, { label: v })} testid={`addon-label-${k}`} /></div>
            <div className="col-span-3"><Txt value={a.description} onChange={(v) => set(k, { description: v })} testid={`addon-desc-${k}`} /></div>
            <div className="col-span-2"><Num value={a.price} onChange={(v) => set(k, { price: v })} testid={`addon-price-${k}`} /></div>
            <div className="col-span-2"><Sel value={a.unit} onChange={(v) => set(k, { unit: v })} options={UNITS} testid={`addon-unit-${k}`} /></div>
            <div className="col-span-1"><Num value={a.order} onChange={(v) => set(k, { order: v })} step="1" testid={`addon-order-${k}`} /></div>
            <div className="col-span-1 flex items-center justify-end gap-1">
              <Toggle on={a.active} onChange={(v) => set(k, { active: v })} label={a.active ? "On" : "Off"} testid={`addon-active-${k}`} />
              <button onClick={() => remove(k)} className="text-brand-muted-light hover:text-red-700 p-1" data-testid={`addon-delete-${k}`} aria-label="Remove"><Trash2 className="w-4 h-4" /></button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
